import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex md:flex-row flex-col items-center md:space-x-3 md:space-y-0 space-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Save Changes", -1)
const _hoisted_3 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_4 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_5 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_6 = { class: "flex items-center justify-between" }

import { ref, computed } from "vue";
 import UserLayout from "@/layouts/UserLayout.vue";
 import SectionTitle from "@/components/partials/SectionTitle.vue";
 import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
 import SuccessModal from "@/components/modals/SuccessModal.vue";
 import FormSection from "./FormSection.vue";
 import { useRouter, useRoute } from "vue-router";
 import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface";
 import { errorResponse } from "@/helpers/errorMessage";
 import pickBy from "lodash/pickBy";
 import { useRecordStatusChecker } from "@/store/recordStatusChecker";
 import { onIonViewWillEnter, onIonViewWillLeave } from "@ionic/vue";
 
 /******************************* For Offline Imports************************************ */
 import { useNetworkStore } from "@/store/network";
 import Rules from "@/classes/Cases/CaseInformant/Offline/Validation/Rules";
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import useVuelidate from "@vuelidate/core";
 import Relationships from "@/classes/Forms/Relationships"; 
 import CaseInformantService from "@/classes/Cases/CaseInformant/CaseInformantService";
 import CaseCompanionForm from "@/classes/Cases/CaseInformant/Offline/Formatters/CaseCompanionForm";
 import { CompanionCreate } from "@/classes/Cases/CaseInformant/Offline/Interface/CompanionInterface"
 import CaseInformantOfflineProcessor from "@/classes/Cases/CaseInformant/Offline/Processor/OfflineProcessor";
 import FormOptions from "@/classes/Forms/FormOptions";

 
export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

 const { createRules } = Rules;
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
 /*************************************************************************************** */
 
 
 const router = useRouter();
 const route = useRoute();
 const showSuccess = ref<boolean>(false);
 const patientId = ref<number | null>(route.params.patient);
 const caseId = ref<number | null>(route.params.case);
 const genders = ref<renderSelectV2[]>([]);
 const companionRelationships = ref<renderSelect[]>([]);
 const options = new FormOptions();
 
 //This form used by both online and offline
 const form = ref<CompanionCreate>(CaseCompanionForm.createForm());
const formRef = ref<any>([]); 

 const errors = ref<object>({});
 const successMessage = ref<string>("New companion has been added!");
 const patient = ref<string>('');
 const recordStatusChecker = useRecordStatusChecker();
 
 
 const save = async (): Promise<any> => {
	errors.value = {};
	console.log("saved");
	const response = await CaseInformantService.store(
		patientId.value,
		caseId.value,
		null,
		{ ...form.value },
		isNetworkAvailable.value
	);
 
	if (response?.status === 200 || response?.data != undefined) {
        if (isNetworkAvailable.value) {
            await CaseInformantOfflineProcessor.syncToOffline(caseId.value, response.data.data.item);
        }
		showSuccess.value = true;
		successMessage.value = response.data.message;
		recordStatusChecker.isCreatedInformant = true;
	} else {
		const error = response;
		errors.value = errorResponse(error.response?.data?.errors);
	}
 };
 
 
 /**
 * Validate the form using Vuelidator
 */
 const validateForm = () =>{
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();

	result
		.then((res) => {
			if(res) {
				save()
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		}) 
 }
 
 
 const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.push(
		`/patient/${patientId.value}/cases/${caseId.value}/edit`
	);
 };
 
 
 const getData = async (): Promise<any> => {
	const response = await CaseInformantService.create(
		patientId.value,
		caseId.value,
		pickBy({}),
		isNetworkAvailable.value
	); 

    if (response?.response?.status === 404) {
        return;
    }

	if (response?.status === 200 || response !== undefined) {
		genders.value = response.data.genders;
		patient.value = response.data.patient;
		companionRelationships.value = options.setOtherToEnd(response.data.companionRelationships);
		
		if(!isNetworkAvailable.value){ 
			genders.value = response.data.genders; 
			companionRelationships.value = options.setOtherToEnd(response.data.companionRelationships); 
		}
	}
 };
 
 
 const resetForm = () => {
	form.value.first_name = null;
	form.value.middle_name = null;
	form.value.last_name = null;
	form.value.gender = null;
	form.value.birthday_classification = null;
	form.value.birthdate = null;
	form.value.approximate_age_year = null;
	form.value.approximate_age_month = null;
	form.value.companion_relationship_id = null;
	form.value.other_relationship = null;
	form.value.contacts = null;

	formRef.value.birthdateForm.datePickerData.picker.clearValue()
 }
 
 
 onIonViewWillLeave(() => resetForm());
 
 
 onIonViewWillEnter(async () => {
	recordStatusChecker.isCreatedInformant = false;
	resetForm();
	await getData();   
 });
 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit`,
    backTitle: "Add New Informant",
    hasBackClass: "flex md:justify-between md:items-center md:flex-row flex-col"
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_unref(router).push(
							`/patient/${patientId.value}/cases/${caseId.value}/edit`
						)
					)),
          class: "md:w-auto w-full md:mt-0 mt-6"
        }, [
          _createVNode(ButtonComponent, {
            btnWidth: "quinary",
            customClass: "quinary md:w-auto w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          })
        ]),
        _createVNode(ButtonComponent, {
          customClass: "primary md:w-auto w-full md:mt-0 mt-6",
          form: "form",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (validateForm()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_4, _toDisplayString(patient.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SectionTitle, { title: "Informant Details" })
        ]),
        _createVNode(FormSection, {
          ref_key: "formRef",
          ref: formRef,
          form: form.value,
          errors: errors.value,
          genders: genders.value,
          companionRelationships: companionRelationships.value,
          "onUpdate:form": _cache[2] || (_cache[2] = (value) => form.value = value)
        }, null, 8, ["form", "errors", "genders", "companionRelationships"])
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Record Save!",
        content: successMessage.value
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})